<div class="bubble-chart" [ngClass]="class">
    <ng-container *ngFor="let chart of dataCharts">
        <div class="bubble-chart-block"
        tabindex="0"
        role="link"
        aria-label="{{chart.name}}"
        [style.width]="chart.size + '%'" 
        [style.top]="chart.top + '%'"
        [style.left]="chart.left + '%'"
        (click)="emitEvent(chart)"
        (keyup.enter)="emitEvent(chart)">
        <svg class="bubble-chart-block-svg" viewBox="0 0 200 250" fill-opacity="0.3">
            <path attr.d="{{chart.backgroundPath}}" attr.fill="{{chart.color}}">
                <animate 
                    attributeName="d" 
                    repeatCount="indefinite" 
                    samples.dur="{{samples}}s"
                    attr.values="{{chart.backgroundAnimation}}">
                </animate>
            </path>
            <path attr.d="{{chart.path}}" attr.fill="{{chart.color}}">
                <animate 
                    attributeName="d" 
                    repeatCount="indefinite" 
                    attr.dur="{{samples}}s" 
                    attr.values="{{chart.animation}}">
                </animate>
            </path>
        </svg>
        <div class="bubble-chart-label">{{chart.name}}</div>
    </div>
    </ng-container>
    
</div>